import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
const formData = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_FORM_DATA_SUCCESS]: (state, { payload }) => payload
  }
);

const formDataStatus = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_FORM_DATA_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_ADVERTISE_FORM_DATA_ERROR]: (state, { type }) => type
  }
);

const categoryList = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_CATEGORY_LIST_SUCCESS]: (state, { payload }) => payload
  }
);

const categoryListStatus = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_CATEGORY_LIST_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_ADVERTISE_CATEGORY_LIST_ERROR]: (state, { type }) => type
  }
);

const whereList = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_WHERE_LIST_SUCCESS]: (state, { payload }) => payload
  }
);

const whereListStatus = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_WHERE_LIST_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_ADVERTISE_WHERE_LIST_ERROR]: (state, { type }) => type
  }
);

const incomingLeads = createReducer([], {
  [ActionTypes.FETCH_ADVERTISE_INCOMING_LEADS_SUCCESS]: (state, { payload }) => payload
});

const incomingLeadsStatus = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_INCOMING_LEADS_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_ADVERTISE_INCOMING_LEADS_ERROR]: (state, { type }) => type
  }
);

const recommendations = createReducer([], {
  [ActionTypes.FETCH_ADVERTISE_RECOMMENDATIONS_SUCCESS]: (state, { payload }) => payload
});

const recommendationsStatus = createReducer(
  {},
  {
    [ActionTypes.FETCH_ADVERTISE_RECOMMENDATIONS_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_ADVERTISE_RECOMMENDATIONS_ERROR]: (state, { type }) => type
  }
);

export default combineReducers({
  formData,
  formDataStatus,
  categoryList,
  categoryListStatus,
  whereList,
  whereListStatus,
  incomingLeads,
  incomingLeadsStatus,
  recommendations,
  recommendationsStatus
});
